module.exports = __webpack_public_path__ + "img/a380.560a9103.jpg";